import { ENDPOINT_PARTIES_CLOSE_PARTY_SLUG } from '@/common/constants';
import { MODAL_KEYS } from '@/common/constants/modal.keys';
import { HttpApi } from '@/common/http';
import Modal from '@/common/modal/Modal';
import { Button } from '@/components/ui/button';
import { useModal } from '@/hooks/useModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { usePartyStore } from '../../store';

const httpApi = new HttpApi();

export const CloseParty = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { closeModal } = useModal(MODAL_KEYS.CLOSE_PARTY);
  const [searchParams] = useSearchParams();
  const pageSize = Number(searchParams.get('size')) || 10;
  const currentPage = Number(searchParams.get('page')) || 1;
  const { fetchParties, partyDetail } = usePartyStore();

  const closeParty = async () => {
    try {
      setIsLoading(true);
      await httpApi.put(
        ENDPOINT_PARTIES_CLOSE_PARTY_SLUG.replace('{slug}', partyDetail?.id!),
        {},
      );
      await fetchParties({ page: currentPage, size: pageSize });
      setIsLoading(false);
      closeModal();
      toast.success(t('data.saved'));
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  return (
    <Modal
      onClose={closeModal}
      modalKey={MODAL_KEYS.CLOSE_PARTY}
      title={
        partyDetail?.is_closed
          ? (t('open.party') as string)
          : (t('close.party') as string)
      }
      description={
        partyDetail?.is_closed
          ? t('open.party.description')
          : t('close.party.description')
      }
    >
      <div className="flex justify-end space-x-2">
        <Button onClick={closeModal} variant="outline">
          {t('no')}
        </Button>
        <Button onClick={closeParty} isLoading={isLoading}>
          {t('yes')}
        </Button>
      </div>
    </Modal>
  );
};
